import { h } from 'preact';
import { Link } from 'preact-router/match';
import {List, BookOpen, Watch} from 'preact-feather';

import style from './style';

const Navigation = () => (
	<footer class={style.footer + " is-fixed"}>
		<nav class="tabs is-center is-full">
			<Link href="/" activeClassName="active">
				<Watch class="icon" />
                <div>Horarios</div>
			</Link>
			<Link href="/list" activeClassName="active">
				<List class="icon" />
                <div>Lista</div>
			</Link>
			<Link href="/guide" activeClassName="active">
				<BookOpen class="icon" /> 
                <div>Guía</div>
			</Link>
		</nav>
	</footer>
);

export default Navigation;



// WEBPACK FOOTER //
// ./components/navigation/index.js